const STORAGE_KEY = "portfolio-app";

type StorageShape = {
  user?: any;
  locale?: string;
  themeId?: string;
};

export const appStorage = {
  get(): StorageShape {
    try {
      const value = window.localStorage.getItem(STORAGE_KEY);
      return value ? JSON.parse(value) : {};
    } catch {
      return {};
    }
  },

  set(values: Partial<StorageShape>): void {
    try {
      const current = appStorage.get();
      const next = { ...current, ...values };
      window.localStorage.setItem(STORAGE_KEY, JSON.stringify(next));
    } catch {
      // fail silently
    }
  },

  clear(): void {
    window.localStorage.removeItem(STORAGE_KEY);
  },
};